<template>
  <div :class="['top10-opportunities-card', {'is-open':isOpen}]">
    <div class="top10-opportunities-card__container">

      <div class="top10-opportunities-card__intro">
        <div class="top10-opportunities-card__image">
          <img :src="payload.image" alt="" width="384" height="244" loading="lazy">
        </div>
        <h3 class="top10-opportunities-card__intro-title">{{ payload.title }}</h3>
        <div v-html="payload.text"></div>
      </div>

      <div class="top-opportunities__cards">
        <template v-for="(job, index) in payload.jobs" :key="index">
          <div class="top-opportunities__card">
            <div class="top-opportunities__card-number">{{ index+1 }}</div>
            <a :href="calculate_link(job)" :title="`${job['org-name']} - ${job.title}`">
              <div class="top-opportunities__card-avatar">
                <div class="top-opportunities__card-logo-container">
                  <img class="top-opportunities__card-logo" :src="$filters.analyseImage(job.logo,'logosm','logoxl')" :alt="job['org-name']" width="54" height="54" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
                </div>
              </div>
              <div class="top-opportunities__card-body">
                <p class="top-opportunities__card-title">{{ job.title }}</p>
                <p class="top-opportunities__card-location">{{ job['location-text'] }}</p>
                <div class="top-opportunities__card-info">
                  <p class="top-opportunities__card-company">{{ job['org-name'] }}</p>

                  <div class="top-opportunities__card-cat" :class="job.type.toLowerCase().trim()">
                    <p>{{ job.type }}</p>
                  </div>
                </div>
              </div>
              <div class="top-opportunities__card-like">
                <block-action-bookmark-job :job_id="job['job-id']"></block-action-bookmark-job>
              </div>
            </a>
          </div>
        </template>
      </div>

    </div>

    <button class="top10-opportunities-card__btn btn btn-blue-dark btn-rounded" @click="readMore">READ</button>

  </div>
</template>

<script>
export default {

	props: {
		payload: {
			type: Object,
      required: true
		},
	},

	data() {
		return {
      isOpen: false,
      maxLength: 600
		}
	},

	mounted() {
		console.log('Top 10 Oppertuniities!', this.payload);
	},

	methods: {
		readMore() {
      this.isOpen = !this.isOpen;
    },
    calculate_link(job) {
			if (job.slug) {
				return '/opportunity/'+job.slug;
			}
			if (job['job-id']) {
				return '/opportunity/redirect/'+job['job-id'];
			}
			return '#';
		}
	}
}
</script>
